<template>
  <div>
    <b-modal
      id="buy-confirmed"
      hide-footer
      no-close-on-backdrop
      modal-class="modern-modal"
      size="lg"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-shopping-cart mr-2"></i>
          Confirmar Compra
        </div>
      </template>

      <div class="filters-section">
        <div class="filters-card">
          <div class="launch-details-table">
            <div class="list-name-section">
              <h5 class="list-name-title">{{ buy_list.name }}</h5>
            </div>

            <div class="group-selection-section">
              <p class="group-selection-title">
                Todos os itens fazem parte do mesmo Grupo de estoque?
              </p>

              <div class="radio-group">
                <label class="radio-label">
                  <input type="radio" :value="true" v-model="allGroup" />
                  Sim
                </label>

                <label class="radio-label">
                  <input type="radio" :value="false" v-model="allGroup" />
                  Não
                </label>
              </div>

              <p class="group-selection-text">Selecione o grupo:</p>

              <div v-if="allGroup" class="select-group">
                <select v-model="stock_group_id" class="form-control">
                  <option value="">SELECIONE...</option>
                  <option
                    v-for="stock in stock_groups"
                    :key="stock.id"
                    :value="stock.id"
                  >
                    {{ stock.name }}
                  </option>
                </select>
              </div>
            </div>

            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>NOME</th>

                  <th>TAMANHO DO ITEM</th>

                  <th>QUANTIDADE</th>

                  <th v-if="allGroup == false">GRUPO</th>

                  <th>DATA DE VENCIMENTO</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(buy, key) in buy_list.itens" :key="key">
                  <td>{{ buy.stock_name }}</td>

                  <td>
                    {{ buy.stock_size }} {{ buy.unit_of_measurement_name }}
                  </td>

                  <td>{{ buy.quantity }}</td>

                  <td v-if="!allGroup">
                    <p class="group-selection-text">Selecione o grupo:</p>

                    <select v-model="buy.stock_group_id" class="form-control">
                      <option value="">SELECIONE...</option>

                      <option
                        v-for="stock in stock_groups"
                        :key="stock.id"
                        :value="stock.id"
                      >
                        {{ stock.name }}
                      </option>
                    </select>
                  </td>

                  <td>
                    <v-text-field
                      v-model="buy.due_date"
                      label="Selecionar Data"
                      type="date"
                      outlined
                      dense
                      hide-details
                      class="modern-input"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-actions">
            <confirmation-dialog
              headerClass="modal-header-ok"
              message-title="Confirmar compra de todos os itens."
              message-body="Assim que a compra for confirmada, os itens serão adicionados ao estoque e essa operação não poderá ser revertida."
              open-class="btn-modern btn-modern-add"
              open-left-icon="fa-check"
              open-text="CONFIRMAR COMPRA"
              @yes="confirmedBuy"
            />
          </div>
        </div>

        <ErrorsMessages :errors="errors" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

export default {
  name: "BuyConfirmed",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },

  props: {
    buy_id: Number,
  },

  data() {
    return {
      loading: false,

      allGroup: true,

      stock_group_id: null,

      buy_list: [],

      stock_groups: [],

      errors: [],
    };
  },

  watch: {
    async buy_id() {
      await this.getBuyList();

      await this.getStockGroups();
    },
  },

  methods: {
    async getBuyList() {
      try {
        this.loading = true;

        const { buy_id } = this;

        let params = { buy_id };
        const response = await api.get("/buy/print", { params });

        const { buy_list } = response.data;

        this.buy_list = buy_list;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async confirmedBuy() {
      try {
        this.loading = true;

        const type = this.buy_list.type;
        const itens = this.buy_list.itens;

        const { buy_id, allGroup, stock_group_id } = this;

        let params = {
          buy_id,
          type,
          itens,
          allGroup,
          stock_group_id,
        };

        const response = await api.put("/buy/confirmed", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("confirmed");

          this.$bvModal.hide("buy-confirmed");
        } else {
          this.errors = errors;

          toast(message, "erro");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getStockGroups() {
      try {
        this.loading = true;

        const type = this.buy_list.type;

        let params = { type };

        const response = await api.get("/rest-home/stock/groups", { params });

        const { error, stock_groups } = response.data;

        if (!error) {
          this.stock_groups = stock_groups;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.form-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

.btn-save-modern {
  margin-left: auto;
}

.launch-details-table {
  margin-bottom: 20px;
}

.launch-details-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.launch-details-table th {
  background-color: #f8f9fa;
  padding: 10px 8px;
  border: 1px solid #ddd;
  font-weight: bold;
  text-align: center;
  font-size: 11px;
}

.launch-details-table td {
  padding: 10px 8px;
  border: 1px solid #ddd;
  vertical-align: middle;
}

.list-name-section {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.list-name-title {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.group-selection-section {
  margin-bottom: 20px;
}

.group-selection-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.group-selection-text {
  font-size: 12px;
  font-weight: 500;
  color: #555;
  margin-bottom: 8px;
}

.radio-group {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.radio-label {
  font-size: 13px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 5px;
}

.select-group {
  margin-top: 10px;
}

.form-control {
  width: 100%;
  padding: 8px;
  font-size: 13px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>